import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Form, Button, Checkbox, Modal, Divider, Row, Col, Spin } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { Apple, CloseIcon, Google } from '../../assets/icons';
import FloatingLabel from '../../components/FloatingLabel/FloatingLabel';
import AuthInfo from '../../components/AuthInfo/AuthInfo';
import AuthForm from '../../components/AuthForm/AuthForm';
import { EmailLoginField } from '../../components/SharedComponents/FormComponents/EmailLoginField';
import { PasswordLoginField } from '../../components/SharedComponents/FormComponents/PasswordLoginField';
import { Images } from '../../config/images';
import './Login.scss';
import { login, resendEmailApi } from '../../services/authApi/authApi';
import { toastNotify } from '../../utils/toastNotify';
import { accountReactivationLinkAction } from '../../store/reducer/accountActivationSlice';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { addUserData, resetUserData } from '../../store/reducer/accountSlice';
import { realBricksApi } from '../../utils/axiosInterceptors';
import { useGoogleLogin } from '@react-oauth/google';
import { LoginSocialApple } from 'reactjs-social-login';
import ReCAPTCHA from 'react-google-recaptcha';
import { AES } from 'crypto-js';
import { setCookieWithExpiryForReferralCode } from '../../utils/cookies';
import { isMobileDeviceDetectRegex } from '../../utils/Validations';
import { generateBranchLinkAndRedirect, resetRedirectingFlag } from '../../utils/branchIoUtils';
import {handleSignupButtonNavigation} from '../../utils/handleLoginSignupRedirection'
import { beginSocialSignup } from '../../utils/socialSignup';

const Login = () => {
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [viewForm, setViewForm] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [isLoginButtonActive, setIsLoginButtonActive] = useState(true);
  const [clickCount, setClickCount] = useState(0);
  const [showCaptcha, setShowCaptcha] = useState(false);
  const [captchaValue, setCaptchaValue] = useState('');
  const [emailLoading, setEmailLoading] = useState(false);
  const [form] = Form.useForm();
  let navigate = useNavigate();
  const search = useLocation().search;
  const location = useLocation();
  const referralLink = new URLSearchParams(search).get('referredBy');
  const dispatch = useDispatch();
  const userProfileData = useSelector((state) => state.userData.userData);

  const isMobileDevice = () => {
    return isMobileDeviceDetectRegex;
  };

  useEffect(() => {
    resetRedirectingFlag();
    if (isMobileDevice()) {
      const redirectIntendedPage = localStorage.getItem('redirectIntendedPage');
      if (!redirectIntendedPage) {
        generateBranchLinkAndRedirect('/login', { feature: 'login' });
      }
      // If redirectIntendedPage exists in localStorage, don't redirect
    }
    
    // Display error message if it exists in localStorage
    const loginErrorMessage = localStorage.getItem('login_error_message');
    if (loginErrorMessage) {
      toastNotify('error', loginErrorMessage);
      localStorage.removeItem('login_error_message');
    }
  }, []);

  useEffect(() => {
    var input = document.getElementById('email');
    setTimeout(() => {
      if (input.matches(':-internal-autofill-selected')) {
        setIsLoginButtonActive(false);
      }
    }, 500);

    if (Object.keys(userProfileData).length && localStorage.getItem('access_token')) {
      navigate('/');
    }
    if (localStorage.getItem('showRecaptcha') === 'true') {
      setShowCaptcha(true);
      localStorage.clear('showRecaptcha');
    }
  }, []);

  const validateEmail = async () => {
    const queryParams = new URLSearchParams(location.search);
    const getURLEmail = queryParams.get('email');
    if (getURLEmail) {
      setEmailLoading(true);
      setEmail(getURLEmail);
      form.setFieldsValue({ email: getURLEmail });
      setEmailLoading(false);
    }
  };

  useEffect(() => {
    validateEmail();
  }, [location.search]);

  // Preserve a ?referredBy= link from the login URL into the referral cookie so it's still
  // picked up later by the Sign Up page (new social signups land there — see beginSocialSignup
  // below), even though this page no longer collects/displays referral info itself.
  useEffect(() => {
    if (referralLink) {
      setCookieWithExpiryForReferralCode('referralcode', referralLink, 60);
    }
  }, [referralLink]);

  const onLoginSuccess = async (response) => {
    const savedRedirectPath = localStorage.getItem('redirectIntendedPage');
    dispatch(resetUserData());
    // localStorage.clear();
    const accessToken = response.access_token;
    try {
      const userResponse = await realBricksApi.post(
        `${process.env.REACT_APP_API_URL}/api/v1/login/google?loginType=Web`,
        {},
        {
          headers: {
            Authorization: `${accessToken}`,
          },
        }
      );
      if (savedRedirectPath) {
        localStorage.setItem('redirectIntendedPage', savedRedirectPath);
      }
      if (userResponse.data.data?.user?.isSignUp) {
        localStorage.setItem('email', userResponse.data.data.user.email);
        localStorage.setItem('access_token', userResponse?.data?.data?.accessToken);
        localStorage.setItem('access_token_temp', userResponse?.data?.data?.accessToken);
        localStorage.setItem('counter', userResponse.data.data.counter);
        if (userResponse?.data?.data?.isNameSet === true) {
          if (userResponse?.data?.data?.isPinSet === false) {
            navigate('/sign-up/createpin');
          } else {
            navigate('/login/enterpin');
          }
        } else {
          beginSocialSignup({ email: userResponse.data.data.user.email, provider: 'google' });
          navigate('/sign-up');
        }
      } else {
        localStorage.setItem('email', userResponse?.data?.data?.email);
        localStorage.setItem('access_token', userResponse?.data?.data?.accessToken);
        localStorage.setItem('access_token_temp', userResponse?.data?.data?.accessToken);
        localStorage.setItem('counter', userResponse.data.data.counter);

        if (userResponse?.data?.data?.isActive) {
          localStorage.setItem('email', userResponse?.data?.data?.email);
          localStorage.setItem('access_token', userResponse?.data?.data?.accessToken);
          localStorage.setItem('counter', userResponse?.data?.data?.counter);
          if (userResponse?.data?.data?.isNameSet === true) {
            if (userResponse?.data?.data?.isPinSet === false) {
              navigate('/sign-up/createpin');
            } else {
              navigate('/login/enterpin');
            }
          } else {
            beginSocialSignup({ email: userResponse?.data?.data?.email, provider: 'google' });
            navigate('/sign-up');
          }
        } else {
          setOpenModal(true);
        }
      }
    } catch (error) {
      const { userResponse } = error;
      toastNotify('error', userResponse?.data?.message);
    }
  };

  const handleGoogleLogin = useGoogleLogin({
    onSuccess: onLoginSuccess,
    clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
    accessType: 'offline',
  });

  const handleLoginClick = async (values) => {
    if (clickCount === 3) {
      localStorage.setItem('showRecaptcha', true);
      window.location.reload();
    } else {
      setClickCount(clickCount + 1);
      setLoading(true);
    }
  };

  const handleResendEmail = async () => {
    try {
      const res = await resendEmailApi();

      if (!res.isError) {
        toastNotify('success', res?.message);
      } else {
        toastNotify('error', res?.message);
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    }
  };

  const handleResendEmailLink = async () => {
    await dispatch(accountReactivationLinkAction({}));
    setOpenModal(false);
  };

  const onAppleLoginSuccess = async (provider, data) => {
    dispatch(resetUserData());
    const savedRedirectPath = localStorage.getItem('redirectIntendedPage');
    // localStorage.clear();

    const idToken = data?.authorization?.id_token;

    try {
      const response = await realBricksApi.post(
        `${process.env.REACT_APP_API_URL}/api/v1/login/apple?loginType=Web`,
        {},
        {
          headers: {
            Authorization: `${idToken}`,
          },
        }
      );
      if (savedRedirectPath) {
        localStorage.setItem('redirectIntendedPage', savedRedirectPath);
      }
      if (response?.data?.data?.user?.isSignUp) {
        localStorage.setItem('email', response?.data?.data?.user?.email);
        localStorage.setItem('access_token', response?.data?.data?.accessToken);
        localStorage.setItem('access_token_temp', response?.data?.data?.accessToken);
        localStorage.setItem('counter', response?.data?.data?.counter);
        if (response?.data?.data?.isNameSet === true) {
          if (response?.data?.data?.isPinSet === false) {
            navigate('/sign-up/createpin');
          } else {
            navigate('/login/enterpin');
          }
        } else {
          beginSocialSignup({ email: response?.data?.data?.user?.email, provider: 'apple' });
          navigate('/sign-up');
        }
      } else {
        localStorage.setItem('email', response?.data?.data?.email);
        localStorage.setItem('access_token', response?.data.data?.accessToken);
        localStorage.setItem('access_token_temp', response?.data.data?.accessToken);
        localStorage.setItem('counter', response?.data?.data?.counter);

        if (response?.data?.data?.isActive) {
          localStorage.setItem('email', response?.data?.data?.email);
          localStorage.setItem('access_token', response?.data?.data?.accessToken);
          localStorage.setItem('access_token_temp', response?.data.data?.accessToken);
          localStorage.setItem('counter', response?.data?.data?.counter);
          if (response?.data?.data?.isNameSet === true) {
            if (response?.data?.data?.isPinSet === false) {
              navigate('/sign-up/createpin');
            } else {
              navigate('/login/enterpin');
            }
          } else {
            beginSocialSignup({ email: response?.data?.data?.email, provider: 'apple' });
            navigate('/sign-up');
          }
        } else {
          navigate('/');
          toastNotify('error', 'Something went wrong');
        }
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    }
  };

  const onResolve = ({ provider, data }) => {
    onAppleLoginSuccess(provider, data);
  };

  const onFinish = async (values) => {
    const savedRedirectPath = localStorage.getItem('redirectIntendedPage') || (location.state?.from || '/');
    setLoading(true);
    if (showCaptcha) {
      setCaptchaValue('');
      setShowCaptcha(false);
      setClickCount(1);
    }
    try {
      const hashedPassword = AES.encrypt(values.password, process.env.REACT_APP_PASSWORD_ENCRYPT_KEY).toString();
      const userData = await login({ ...values, password: hashedPassword }, 'Web', rememberMe);
      if (!userData.isError) {
        await dispatch(addUserData({ userData: {}, isPinEntered: false }));
        localStorage.clear(); //clear localstorage
        const { accessToken, refreshToken = null, counter } = userData.data;
        await localStorage.setItem('access_token_temp', accessToken);
        refreshToken && (await localStorage.setItem('refresh_token', refreshToken));
        await localStorage.setItem('email', values.email);
        await localStorage.setItem('counter', counter);
        if (savedRedirectPath && savedRedirectPath !== '/' && savedRedirectPath !== '/login') {
          localStorage.setItem('redirectIntendedPage', savedRedirectPath);
        }
        if (userData?.data?.isActive) {
          if (!userData.data.isEmailVerified) {
            await handleResendEmail();
            navigate('/sign-up/activation');
            return;
          }
          if (!userData.data.isPinSet) {
            navigate('/sign-up/createpin');
            return;
          }
          navigate('/login/enterpin');
        } else {
          setOpenModal(true);
        }
      } else {
        toastNotify('error', userData?.message);
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const onChange = (value) => {
    setCaptchaValue(value);
  };
  return (
    <div className='auth auth--details auth--no-info-mobile login'>
      <AuthInfo
        className={viewForm ? 'hide' : null}
        title={<>Welcome back</>}
        description={<>Enter your credentials to access your Realbricks account.</>}
      >
        <div className='mobile-action' onClick={() => setViewForm(true)}>
          <Button className='w-100'>Get Started</Button>
        </div>
      </AuthInfo>
      <AuthForm
        className={viewForm ? 'show' : null}
        note={
          <>
            <span className='hide-mobile mr-4'>Don’t have an account?</span>
            <a
              href='sign-upAuth'
              className='underline fw-600 text-terracotta'
              onClick={handleSignupButtonNavigation}
            >
              Sign up
            </a>
          </>
        }
        title={<>Log in to your account</>}
      >
        <Row gutter={[16, 16]} className='mb-32 pt-10'>
          <Col span={24} lg={12}>
            <Button type='primary' className='ant-btn-primary--alt icon-btn' block onClick={() => handleGoogleLogin()}>
              <Google size={16} /> Continue with Google
            </Button>
          </Col>
          <Col span={24} lg={12}>
            <LoginSocialApple
              client_id={process.env.REACT_APP_APPLE_CLIENT_ID}
              redirect_uri={process.env.REACT_APP_APPLE_REDIRECT_URL}
              onResolve={onResolve}
              onReject={(err) => {
                toastNotify('error', err);
              }}
            >
              <Button type='primary' className='ant-btn-primary--alt icon-btn' block>
                <Apple size={16} /> Continue with Apple
              </Button>
            </LoginSocialApple>
          </Col>
        </Row>
        <Divider plain>OR</Divider>
        <Form name='login-form' className='auth-form details-form' autoComplete='off' onFinish={onFinish} form={form}>
          <Spin spinning={emailLoading}>
            <FloatingLabel label='Email' name='email' inputValue={email}>
              <EmailLoginField email={email} setEmail={(value) => setEmail(value)} />
            </FloatingLabel>
            <FloatingLabel label='Password' name='password' inputValue={password}>
              <PasswordLoginField name={'password'} setPassword={(value) => setPassword(value)} password={password} validation={false} />
            </FloatingLabel>
          </Spin>
          <Link to='/forgot-password/enter-email' className='underline fw-600 text-terracotta'>
            Forgot password
          </Link>
          {showCaptcha && <ReCAPTCHA className='mt-24' sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY} onChange={onChange} />}
          <Form.Item className='auth-form__login-submit' shouldUpdate>
            {() => (
              <React.Fragment>
                <Checkbox onChange={(e) => setRememberMe(e.target.checked)}>Remember me for 30 days</Checkbox>
                <Button
                  type='primary'
                  htmlType='submit'
                  className='ant-btn-primary--alt'
                  loading={loading}
                  onClick={handleLoginClick}
                  disabled={
                    (showCaptcha && captchaValue === '') ||
                    (isLoginButtonActive && !form.isFieldsTouched(true)) ||
                    form.getFieldsError().filter(({ errors }) => errors.length).length > 0
                  }
                >
                  Log in
                </Button>
              </React.Fragment>
            )}
          </Form.Item>
        </Form>
      </AuthForm>
      <Modal open={openModal} width={524} closeIcon={<CloseIcon />} onCancel={() => setOpenModal(false)} footer={false} centered>
        <div className='text-center mb-16'>
          <LazyLoadImage src={Images.reactivate} alt='Reactivate Icon' />
        </div>
        <h4 className='text-center'>Reactivate your account</h4>
        <p>
          We have recovered your old Realbricks account. Check your inbox to reactivate it. We have sent an email to{' '}
          <span className='fw-600'>{email}</span>
        </p>
        <p>
          The link will expire in 10 minutes.{' '}
          <span onClick={() => handleResendEmailLink()} className='fw-600 underline text-terracotta cursor-pointer'>
            Resend the email
          </span>{' '}
          if you didn’t receive one, or{' '}
          <a href='https://example.com' className='fw-600 underline text-terracotta'>
            contact support
          </a>{' '}
          with any issues.
        </p>
      </Modal>
    </div>
  );
};

export default Login;
